module.exports = __webpack_public_path__ + "Server-Unknown-None.127bf2226c0872df38c5372556a4be6c.hashedasset.svg";